// extracted by mini-css-extract-plugin
export default {"tooltip":"DQ-z","arrow":"EQ-z"};